//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class MembershipSubscriptionInputItem extends ItemBase {
    PaymentMethodID: string | null = null;
    SetupIntentID: string | null = null;
    StripeCustomerID: string | null = null;
    MembershipPlanID: string | null = null;
    ReturnURL: string | null = null;

    constructor(initializer?: Partial<MembershipSubscriptionInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipSubscriptionInputItem";
}
